<template>
  <div class="employDetail">
    <el-form
      :model="formData"
      label-width="125px"
      class="form-horizontal detail-form detail-text-form"
    >
      <el-collapse class="w-p-100" v-model="activeNames">
        <el-collapse-item title="经营人信息" name="2">
          <div class="detail-box">
            <el-form-item class="sp-width-50" label="经营人：">
              {{ formData.realManagerName }}
            </el-form-item>
            <el-form-item class="sp-width-50" label="联系电话：">
              {{ formData.realManagerPhone }}
            </el-form-item>
            <el-form-item class="sp-width-50" label="国籍：">
              {{ formData.realManagerCountryName }}
            </el-form-item>
            <el-form-item class="sp-width-50" label="外文姓名：">
              {{ formData.realManagerFirstName + ' ' + formData.realManagerLastName }}
            </el-form-item>
            <el-form-item class="sp-width-50" label="证件种类：">
              {{ formData.realManagerCertTypeName }}
            </el-form-item>
            <el-form-item class="sp-width-50" label="证件号码：">
              {{ formData.realManagerCertCode }}
            </el-form-item>
            <el-form-item class="sp-width-100" label="实际居住地：">
              {{ formData.realManagerAddr }}
            </el-form-item>
          </div>
        </el-collapse-item>
        <el-collapse-item title="经营单位信息" name="3" v-show="isShowCompany">
          <div class="detail-box">
            <el-form-item class="sp-width-100" label="经营单位：">
              {{ formData.companyName }}
            </el-form-item>
            <el-form-item class="sp-width-50" label="社会信用代码：">
              {{ formData.companyCreditCode }}
            </el-form-item>
            <el-form-item class="sp-width-50" label="单位联系电话：">
              {{ formData.companyPhone }}
            </el-form-item>
            <el-form-item class="sp-width-50" label="法人：">
              {{ formData.corporationName }}
            </el-form-item>
            <el-form-item class="sp-width-50" label="法人联系电话：">
              {{ formData.corporationPhone }}
            </el-form-item>
            <el-form-item class="sp-width-50" label="法人国籍：">
              {{ formData.realManagerCountryName }}
            </el-form-item>
            <el-form-item class="sp-width-50" label="法人外文姓名：">
              {{ formData.corporationFirstName + ' ' + formData.corporationLastName }}
            </el-form-item>
            <el-form-item class="sp-width-50" label="法人证件种类：">
              {{ formData.corporationCertTypeName }}
            </el-form-item>
            <el-form-item class="sp-width-50" label="法人证件号码：">
              {{ formData.corporationCertCode }}
            </el-form-item>
            <el-form-item class="sp-width-100" label="法人实际居住地：">
              {{ formData.corporationAddr }}
            </el-form-item>
          </div>
        </el-collapse-item>
        <el-collapse-item title="审核信息" name="1">
          <div class="check-containor">
            <el-radio v-model="reviewStatus" label="2">通过</el-radio>
            <el-radio v-model="reviewStatus" label="3">不通过</el-radio>
            <el-input class="check-reason" type="textarea" :autosize="{ minRows: 3, maxRows: 6}" placeholder="请输入审核理由" v-model="reviewInfo"></el-input>
          </div>
        </el-collapse-item>
      </el-collapse>

      <div class="footer-btn">
        <el-button class="submit-btn" @click="handleCheck">确定</el-button>
        <el-button class="cancel-btn" @click="handleCancel">取消</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import RTable from '@/components/common/RTable'
import tableMix from '@/components/common/tableListMixin.js'
export default {
  name: 'employeeCheck',
  mixins: [tableMix],
  components: { RTable },
  emits: ['closeModel'],
  props: {
    detailModal: { type: Boolean, default: false },
    detailData: { type: Object, default: () => ({ id: '$%&' }) },
    isEncry: { type: Boolean, default: true },
    encryList: { type: Object, default: () => ({}) },
    encryFunc: { type: Function, default: () => {} }
  },
  data() {
    let detailKeys = [
      'realManagerName',
      'realManagerCertCode',
      'realManagerLastName',
      'realManagerFirstName',
      'realManagerPhone',
      'realManagerAddr',
      'companyName',
      'companyCreditCode',
      'companyPhone',
      'corporationName',
      'corporationCertCode',
      'corporationLastName',
      'corporationFirstName',
      'corporationPhone',
      'corporationAddr',
      'realManagerCountryName',
      'realManagerCertTypeName',
      'corporationCertTypeName',
    ]
    let formData = {}
    detailKeys.map((key) => {
      formData[key] = ''
    })
    return {
      isShowCompany: false,
      activeNames: ['1', '2', '3', '4', '5', '6'],
      formData,
      reviewStatus: '2',
      reviewInfo: '',
    }
  },
  created() {
    this.getDetail()
  },
  watch: {
    detailModal(val) {
      if (val === false) {
        return false
      }
      this.getDetail()
    },
  },
  methods: {
    // 获取详情
    getDetail() {
      let params = {
        id: this.detailData.id
      };
      let url = "MANAGER.GET_DETAIL";
      this.fetchData({ url, method: "get", params }).then(res => {
        res = res || {}
        this.buildFormData(res)
      })
    },
    // 构建详情
    buildFormData(data) {
      this.formData = Object.assign(this.formData, data)

      if (this.isEncry) {
        for (let key in this.encryList) {
          for (let formKey in this.formData) {
            if (key === formKey) {
              this.formData[formKey] = this.encryFunc(this.formData[formKey], this.encryList[key])
            }
          }
        }
      }

      for (let key in this.formData) {
        if (this.formData[key] === '' || this.formData[key] == null) {
          this.formData[key] = '--'
        }
      }

      this.isShowCompany = false
      if (this.detailData.manageType == 2) {
        this.isShowCompany = true
      }
    },
    // 处理审核
    handleCheck() {
      let url = "MANAGER.POST_REVIEW"
      let params = {
        id: this.detailData.id,
        reviewInfo: this.reviewInfo,
        reviewStatus: this.reviewStatus,
      }
      
      this.fetchData({url, method: 'post', params, headers: { "Content-Type": "application/json" }}).then(res => {
        this.$message.success('操作成功！')
        this.$emit('submitSuccess')
      })
    },
    handleCancel() {
      this.$emit('closeModel')
    },
  },
}
</script>

<style lang="less" scoped>
.detail-form {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
}
.check-containor {
  margin-left: 30px;
}
.check-reason {
  margin-top: 10px;
}
.sp-width-100 {
  width: 100% !important;
  margin-bottom: 0;
}
.sp-width-50 {
  width: 50% !important;
  margin-bottom: 0;
}
.footer-btn {
  text-align: center;
  padding: 20px;
  width: 100%;
}
.detail-box {
  display: flex;
  flex-wrap: wrap;
}
</style>
